export function filterByIsClosed(locations) {
  return locations.filter(
    location =>
      Object.prototype.hasOwnProperty.call(
        location,
        'does_deliver_to_address'
      ) && location.is_closed
  );
}
